module.exports = __webpack_public_path__ + "img/error.99a5c043.png";